import React, { useRef } from 'react';
import { RiImageAddLine } from 'react-icons/ri';
import addjob from '../../css/style.module.css'

const ImageUpload = ({ label, name, onChange, imagePreview, onClear, clear, mode = "write" }) => {
    const fileInputRef = useRef(null);

    const handleUploadClick = () => {
        if (mode === "write") {
            fileInputRef.current?.click();
        }
    };


    return (
        <div className={addjob.addbannercontainer}>
            <label>{label}</label>
            <div className={addjob.addbannerinput}>
                {imagePreview ? (
                    <>
                        <div className={addjob.editbannerimage}>
                            <img src={imagePreview} alt="" />
                        </div>
                        {mode === "write" && (
                            clear ? (
                                <span onClick={onClear}></span>
                            ) : (
                                <span onClick={onClear}>Clear</span>
                            )
                        )}
                    </>
                ) : (
                    mode === "write" && (
                        <>
                            <div
                                className={addjob.addbannerupload}
                                onClick={handleUploadClick}
                            >
                                <RiImageAddLine color='#8D98AA' size={35} />
                                <p>Upload your file</p>
                            </div>
                            <span>Max 2MB</span>
                        </>
                    )
                )}
            </div>

            {mode === "write" && (
                <input
                    type="file"
                    name={name}
                    ref={fileInputRef}
                    hidden
                    onChange={onChange}
                />
            )}
        </div>
    );
};

export default ImageUpload;
